import * as React from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Button } from '@mui/material'
import CalendarTodayIcon from '@mui/icons-material/CalendarToday'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3'
import { format } from 'date-fns'

/**
 * DeliveryDatePicker component for selecting a delivery date.
 */
const DeliveryDatePicker = () => {
  const [open, setOpen] = React.useState(false)
  const anchorEl = React.useRef(null) // Create a ref for the button
  const navigate = useNavigate()
  const { deliveryDate } = useParams()
  const deliveryDateObj = new Date(deliveryDate)

  // Selecting delivery date
  const selectDeliveryDate = (newDeliveryDate) => {
    const newDeliveryDateFormatted = format(newDeliveryDate, 'yyyy-MM-dd')
    navigate('/' + location.pathname.split('/')[1] + '/' + newDeliveryDateFormatted, { replace: true })
  }

  // Function to disable all days except Monday and Thursday
  const shouldDisableDate = (date) => {
    const day = date.getDay()
    return day !== 1 && day !== 4 // 1 = Monday, 4 = Thursday
  }

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Button variant="contained" startIcon={<CalendarTodayIcon />} onClick={() => setOpen(true)} ref={(node) => (anchorEl.current = node)}>
        {format(deliveryDateObj, 'EEEE - MM/dd/yyyy')}
      </Button>
      <DatePicker
        open={open}
        onClose={() => setOpen(false)}
        value={deliveryDateObj}
        onChange={selectDeliveryDate}
        slots={{
          textField: () => null, // Hide the default TextField slot
        }}
        slotProps={{
          popper: {
            anchorEl: anchorEl.current, // Use the ref for positioning
            placement: 'bottom-end',
          },
        }}
        shouldDisableDate={shouldDisableDate}
      />
    </LocalizationProvider>
  )
}

export default DeliveryDatePicker
